import { render, staticRenderFns } from "./DepProgressTab.vue?vue&type=template&id=0215e5e9&scoped=true&"
import script from "./DepProgressTab.vue?vue&type=script&lang=js&"
export * from "./DepProgressTab.vue?vue&type=script&lang=js&"
import style0 from "./DepProgressTab.vue?vue&type=style&index=0&id=0215e5e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215e5e9",
  null
  
)

export default component.exports